const host = typeof window === 'undefined' ? '' : window.location.host;
export const isEventsEnabled = process.env.NODE_ENV === 'production' && !host.includes('staging');
